import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NEWS_STATUS, NEWS_TYPES, USER_ROLES } from 'src/app/enums/enums';
import { News } from 'src/app/models/news.model';
import { NewsService } from 'src/app/services/news.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserService } from 'src/app/services/user.service';
declare var $: any;
  
@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css'],
  providers: [NewsService, StorageService, UserService]
})
export class NoticiasComponent implements OnInit {
  public news:          News[];
  public status:        string;
  public identity:      string;
  public token:         string;
  public noticia:       News;
  public form:          FormData = new FormData();
  public loading:       boolean = false;
  public isSubmitting:  boolean = false;
  public isDeleting:    boolean = false;
  public isUpdating:    boolean = false;
  public page:          number = 1;
  public pageSize:      number = 10;
  public filenames:     string[] = [
    '', '', '', ''
  ];
  public newsTypes      = Object.values(NEWS_TYPES);

  constructor(
    private _newsService:     NewsService,
    private _storageService:  StorageService,
    private _userService:     UserService,
    private _router:          Router,
    protected _sanitizer:     DomSanitizer,
  ) {
    this.cleanNews();
  }

  ngOnInit(): void {
    $('html,body').scrollTop(0);
    this.identity = this._userService.getIdentity();
    this.token    = this._userService.getToken();
    if (!this.identity || !this.token)
      this._router.navigate(['/iniciar-sesion']);
    else 
      this.listarNoticias();
  }

  validateRoles(roles: string[], role: USER_ROLES): boolean {
    return roles.includes(role);
  }

  listarNoticias(): void {
    this.loading = true;
    this._newsService.getNewsForAdmin().subscribe(
      res => {
        if (res.news.length <= 0) {
          this.status = 'error';
        } else {
          if (res.news.length === 0) {
            alert('No hay noticias para mostrar');
          } else {
            this.news = res.news;
            this.news = this.sortArray(this.news);
          }
          this.status = 'ok';
        }
        this.loading = false;
      },
      err => this.onError(err)
    );
  }

  sortArray(arrayObj: any[]): any[] {
    return arrayObj.sort((a, b) =>
      (b.creationDate + b.creationTime).localeCompare(a.creationDate + a.creationTime)
    );
  }

  setNews(news: News): void {
    this.noticia = news;
  }

  agregarNoticia(): void {
    if (
      !this.noticia.title ||
      !this.noticia.author ||
      !this.noticia.creationDate ||
      !this.noticia.creationTime ||
      !this.form.get('imagen0')
    ) {
      return alert('Por favor, rellene los campos obligatorios');
    }
    this.isSubmitting = true;

    let uploadImagesPromises = [];
    for (let i = 0; i < this.filenames.length; i++) {
      if (this.form.get('imagen' + i))
        uploadImagesPromises.push(this.subirImagen(this.form.get('imagen' + i), this.filenames[i], i));
    }

    Promise.all(uploadImagesPromises).then(() => {
      this._newsService.addNews(this.noticia).subscribe(
        response => {
          if (!response.news) {
            this.status = 'error';
          } else {
            this.news.push({ ...response.news });
            this.news = this.sortArray(this.news);
            this.cleanNews();
            this.status = 'ok';
          }
          this.isSubmitting = false;
        },
        err => this.onError(err)
      );
    }).catch(err => this.onError(err));
  }

  subirImagen(file: any, filename: string, index: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this._storageService.uploadFile('news', filename, file).then(res => {
        if (index == 0) {
          this.noticia.image = res;
        } else {
          this.noticia['image' + index] = res;
        }
         resolve();
      }).catch(err => this.onError(err));
    });
  }

  eliminarNoticia(): void {
    this.isDeleting = true;
    let deleteImagesPromises = [];
    for (let i = 0; i < this.filenames.length; i++) {
      if (!i) {
        if (this.noticia.image)
          deleteImagesPromises.push(this.eliminarImagen(this.noticia.image));
      } else {
        if (this.noticia['image' + i])
          deleteImagesPromises.push(this.eliminarImagen(this.noticia['image' + i]));
      }
    }
    Promise.all(deleteImagesPromises).then(() => {
      this._newsService.deleteNews(this.noticia.id).subscribe(
        res => {
          alert(res.message);
          this.isDeleting = false;
          this.listarNoticias();
          this.cleanNews();
        },
        err => this.onError(err)
      );
    }).catch(err => this.onError(err));
  }

  eliminarImagen(image: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this._storageService.deleteFileByUrl(image).then(() => {
        resolve();
      }).catch(err => this.onError(err));
    });
  }

  actualizarNoticia(): void {
    if (!this.noticia.author || !this.noticia.creationDate || !this.noticia.creationTime) {
      return alert('Por favor, rellene los campos obligatorios');
    }
    this.isUpdating = true;
    let uploadImagesPromises = [];
    let deleteImagesPromises = [];
    for (let i = 0; i < this.filenames.length; i++) {
      if (this.form.get('imagen' + i)) {
        uploadImagesPromises.push(this.subirImagen(this.form.get('imagen0'), this.filenames[i], i));
        if (!i) {
          if (this.noticia.image)
            deleteImagesPromises.push(this.eliminarImagen(this.noticia.image));
        } else {
          if (this.noticia['image' + i])
            deleteImagesPromises.push(this.eliminarImagen(this.noticia['image' + i]));
        }
      }
    }
    Promise.all(deleteImagesPromises).then(()=> {
      Promise.all(uploadImagesPromises).then(() => {
        console.log(this.noticia)
        this._newsService.updateNews(this.noticia).subscribe(
          response => {
            if (!response.news) {
              this.status = 'error';
            } else {
              this.listarNoticias();
              this.news = this.sortArray(this.news);
              this.cleanNews();
              this.status = 'ok';
            }
            this.isUpdating = false;
          },
          err => this.onError(err)
        )
      }).catch(err => this.onError(err));
    }).catch(err => this.onError(err));
  }

  onFileChange(e: any, idx: number) {
    if (e.target.files.length > 0) {
      for (let i = 0; i < e.target.files.length; i++) {
        this.filenames[idx] = e.target.files[i].name;
        $('#add-image-label' + idx).html(this.filenames[idx]);
        $('#update-image-label' + idx).html(this.filenames[idx]);
        this.form.delete('imagen' + idx);
        this.form.append('imagen' + idx, e.target.files[i], this.filenames[idx]);
      }
    }
  }

  cleanNews() {
    this.noticia = new News('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', NEWS_STATUS.ACTIVE, NEWS_TYPES.GENERAL);
    for (let i = 0; i < this.filenames.length; i++) {
      this.filenames[i] = '';
      this.form.delete('imagen' + i);
      $('#add-image-label' + i).html('Buscar imagen');
      $('#update-image-label' + i).html('Buscar imagen');
    }
  }

  onError(error: any): void {
    let errorMessage = error;
    alert("Error al ejecutar la acción");
    if (errorMessage != null) {
      this.status = 'error';
    }
    this.loading = false;
    this.isSubmitting = false;
    this.isDeleting = false;
    this.isUpdating = false;
  }

  cleanURL(oldURL: string): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustUrl(oldURL);
  }
}
